import { Modal } from "@covertree/ui";
import { useAccessPattern } from "@hooks/useAccessPattern";
import { useContinueQuote } from "@providers/ContinueQuoteProvider";
import { useContinueQuoteForm } from "./useContinueYourQuoteForm";
import { ContinueYourQuoteModalContent } from "./ContinueYourQuoteModalContent/ContinueYourQuoteModalContent";

export function ContinueYourQuoteModal() {
  const { isInternalAgent } = useAccessPattern();
  const {
    isModalOpen,
    canContinueQuote,
    policyLocator,
    defaultEffectiveDate,
    closeContinueQuoteModal,
    submitContinueQuote,
  } = useContinueQuote();

  const { control, handleSubmit, isValid, emailAddress, disclaimerMessage } =
    useContinueQuoteForm({
      defaultEffectiveDate,
      isInternalAgent,
      onSubmit: submitContinueQuote,
    });

  return (
    <Modal
      open={isModalOpen}
      onClose={closeContinueQuoteModal}
      title="Continue your quote"
      maxWidth="sm"
      sx={{
        "&:focus": {
          outline: "none",
        },
      }}>
      <ContinueYourQuoteModalContent
        canContinueQuote={canContinueQuote}
        closeContinueQuoteModal={closeContinueQuoteModal}
        control={control}
        disclaimerMessage={disclaimerMessage}
        emailAddress={emailAddress}
        handleSubmit={handleSubmit}
        isValid={isValid}
        policyLocator={policyLocator}
      />
    </Modal>
  );
}
